import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import OutputAreasMap, {pointerInfoEmpty} from "components/visuals/maps/OutputAreasMap";
import useColourPalette from "components/visuals/useColourPalette";

import CatchmentAreaPenPortraitClassificationPopup from "./CatchmentAreaPenPortraitClassificationPopup";
import CatchmentAreaPenPortraitClassificationLegend from "./CatchmentAreaPenPortraitClassificationLegend";
import StoreMarker from "./StoreMarker";

import { selectMapboxConfiguration } from "modules/siteConfiguration/siteConfigurationSlice";
import { selectors } from "modules/customer/insights/portfolio/catchment/customerProfiles";

const CatchmentAreaPenPortraitClassification = () => {
    const colourPalette = useColourPalette();
    const mapboxConfiguration = useSelector(selectMapboxConfiguration);
    const catchmentAreaPenPortraitClassification = useSelector(state => selectors.catchmentAreaPenPortraitClassification(state));
    const { loading, error, mapCenter, penPortraitClassifications } = catchmentAreaPenPortraitClassification;
    const outputAreas = penPortraitClassifications.map(item => ({
        code: item.outputAreaCode,
        colourGroup: parseInt(item.classification) - 1
    }));
    const [initialViewport, setInitialViewport] = React.useState({
        latitude: mapCenter.latitude,
        longitude: mapCenter.longitude,
        zoom: 13.5
    });
    const [hoverInfo, setHoverInfo] = React.useState(pointerInfoEmpty);
    const [clickInfo, setClickInfo] = React.useState(pointerInfoEmpty);

    React.useEffect(() => {
        setInitialViewport(current => {
            return {
                ...current,
                latitude: mapCenter.latitude,
                longitude: mapCenter.longitude
            };
        });
    }, [mapCenter]);

    return (
        <Box data-cy="catchment-area-pen-portrait-classification">
            <OutputAreasMap
                loading={loading}
                error={error}
                mapboxAccessToken={mapboxConfiguration.accessToken}
                mapboxBaseMapStyle={mapboxConfiguration.baseMapStyle}
                mapboxOutputAreasTilesetId={mapboxConfiguration.outputAreasTilesetId}
                mapboxOutputAreasTilesetUrl={mapboxConfiguration.outputAreasTilesetUrl}
                initialViewport={initialViewport}
                addGeocoder={false}
                outputAreas={outputAreas}
                colours={colourPalette.categorical}
                onHover={setHoverInfo}
                onClick={setClickInfo}
                downloadData={penPortraitClassifications}
            >
                <CatchmentAreaPenPortraitClassificationLegend />
                <CatchmentAreaPenPortraitClassificationPopup
                    penPortraitClassifications={penPortraitClassifications}
                    hoverInfo={hoverInfo}
                    clickInfo={clickInfo}
                />
                <StoreMarker mapCenter={mapCenter}/>
            </OutputAreasMap>
        </Box>
    );
};

export default CatchmentAreaPenPortraitClassification;
